import React from 'react';

const CopyIcon = () => {
  return (
    <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M15.625 21.25a.627.627 0 0 0-.625.625v.625c0 .69-.56 1.25-1.25 1.25H7.5c-.69 0-1.25-.56-1.25-1.25v-10c0-.69.56-1.25 1.25-1.25h4.375a.627.627 0 0 0 .625-.625.627.627 0 0 0-.625-.625H7.5A2.5 2.5 0 0 0 5 12.5v10C5 23.879 6.12 25 7.5 25h6.25a2.5 2.5 0 0 0 2.5-2.5v-.625a.627.627 0 0 0-.625-.625zm9.008-12.866-3.017-3.018A1.247 1.247 0 0 0 20.73 5h-4.48c-1.38 0-2.5 1.12-2.5 2.5v10a2.5 2.5 0 0 0 2.5 2.5h6.25a2.5 2.5 0 0 0 2.5-2.5V9.27c0-.332-.133-.652-.368-.886zM21.25 6.768l1.98 1.982h-1.98V6.768zm2.5 10.732c0 .69-.56 1.25-1.25 1.25h-6.25c-.69 0-1.25-.56-1.25-1.25v-10c0-.69.56-1.25 1.25-1.25H20v2.5c0 .69.56 1.25 1.25 1.25h2.5v7.5z"
        fill="currentColor"
      />
    </svg>
  );
};

export default CopyIcon;
